import type { ApiClient } from "../../../app/api/client";
import type { PersonDocumentRow } from "./personDetailTypes";

/** Metadaten eines Personendokuments aus der Aktenliste, oder null wenn die Id nicht vorkommt. */
export async function findPersonDocument(
  api: ApiClient,
  personId: string,
  documentId: string
): Promise<PersonDocumentRow | null> {
  const list = await api.get<PersonDocumentRow[]>(`/api/v1/persons/${encodeURIComponent(personId)}/documents`);
  return (list || []).find((document) => document.id === documentId) || null;
}
